// s126 Batch 2 item 1 — derive agency sub-bands from task ORDER (no schema change).
//
// A band is a maximal run of ADJACENT tasks sharing an agencyKey, threshold ≥2 (a
// singleton gets no band). Callers pass ONE stage's ordered active tasks, so a band can
// never cross a stage boundary — the same agency appearing in two stages yields two
// separate bands. The label is the registry display name carried on each row (seam-safe).

export interface AgencyGroupable {
  agencyKey?: string | null;
  agencyName?: string | null;
}

export type AgencySegment<T> =
  | { kind: "band"; agencyKey: string; agencyName: string; tasks: T[] }
  | { kind: "loose"; tasks: T[] };

export function deriveAgencyBands<T extends AgencyGroupable>(tasks: T[]): AgencySegment<T>[] {
  const segs: AgencySegment<T>[] = [];
  let i = 0;
  while (i < tasks.length) {
    const key = tasks[i].agencyKey;
    if (key) {
      let j = i + 1;
      while (j < tasks.length && tasks[j].agencyKey === key) j++;
      if (j - i >= 2) {
        segs.push({ kind: "band", agencyKey: key, agencyName: tasks[i].agencyName || key, tasks: tasks.slice(i, j) });
        i = j;
        continue;
      }
    }
    const last = segs[segs.length - 1];
    if (last && last.kind === "loose") last.tasks.push(tasks[i]);
    else segs.push({ kind: "loose", tasks: [tasks[i]] });
    i++;
  }
  return segs;
}
